exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-orient: vertical;\r\n  -webkit-box-direction: normal;\r\n      -ms-flex-flow: column nowrap;\r\n          flex-flow: column nowrap;\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\n\r\n.autocomplete-container {\r\n  background-color: #FFF;\r\n  position: absolute;\r\n  top: 5px;\r\n  left: 5px;\r\n  right: 5px;\r\n  z-index: 100;\r\n}\r\n\r\n.autocomplete-placeholder {\r\n  color: rgba(0, 0, 0, 0.87);\r\n}\r\n\r\n.autocomplete-input {\r\n  color: #000;\r\n}\r\n\r\n.map {\r\n  height: 100%;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/profile/location/location.component.css
// module id = ../../../../../src/app/profile/location/location.component.css
// module chunks = 4